<template>
  <div id="bannerVideo" :class="{ 'bgImage': bgImage }">
    <div class="shadow-box">
      <div
        class="mask"
        v-if="isOpen"
      ></div>
      <p class="title">{{title}}</p>
      <p class="intro-des" :class="vwClass ? 'intro-des-vw' : ''">{{message}}</p>
      <div v-if="videoUrl" class="row-btn">
        <div
          class="playBtn"
          @click="goPlay"
        >
          <img
            class="icon-play"
            src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/icon-play-white.png"
          >
          <p class="btn-mes">观看视频</p>
        </div>
        <div
          @click="toSign"
          class="playBtn haoke-register"
        >
          <p class="btn-mes">{{ vwClass ? '机构注册' : '好课注册' }}</p>
        </div>
      </div>

    </div>
    <!-- <div :id="id" ref="player"></div> -->

    <div v-if="bgImage" class="bannerVideo-gb">
      <img :src="bgImage" alt="">
    </div>
    <video
      v-if="videoUrl"
      class="video-box"
      muted
      loop
      autoplay="autoplay"
    >
      <source
        :src="videoUrl"
        type="video/mp4"
      >
    </video>
    <div
      v-if="isOpen"
      class="video-player"
    >
      <!-- <video class="video-player-box">
              <source :src="videoUrl" type="video/mp4">
          </video> -->
      <img
        class="icon-close"
        @click="isOpen = false"
        src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/icon-close.png"
      >
      <Xgplayer
        :config="config"
        @player="Player = $event"
      />
    </div>
  </div>
</template>
<script>
import Xgplayer from 'xgplayer-vue'
// vwClass 学习机tap传进来的
export default {
  props: {
    videoUrl: {
      type: String,
      default: ''
    },
    allVideoUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      default: ''
    },
    bgImage: {
      type: String,
      default: ''
    },
    vwClass: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      config: {
        id: 'vs',
        url: this.allVideoUrl,
        width: '100%',
        height: '100%',
        autoplay: true
      },
      isOpen: false
    }
  },
  components: { Xgplayer },
  methods: {
    goPlay () {
      this.isOpen = true
    },
    toSign () {
      this.$router.push({ name: 'signUp' })
    }
  }
}
</script>
<style lang="scss" scoped>
.bgImage {
  height: 807px!important;
  background-color: #F53E3E;
}
#bannerVideo {
  width: 100%;
  height: vw(807);
  min-height: 807px;
  max-height: 931px;
  max-width: 1920px;
  margin: 0 auto;
  position: relative;
  border: none;
  .shadow-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    color: rgba(255, 255, 255, 1);
    z-index: 90;
    background: rgba(0, 0, 0, 0.3);
    padding-left: vw(167);
    text-align: left;
    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 1);
      z-index: 100;
    }
    .title {
      font-family: PingFangSC-Semibold;
      font-size: vw(40);
      color: #f8f9fd;
      line-height: vw(56);
      margin-top: vw(167);
    }
    .row-btn {
      display: flex;
    }
    .playBtn {
      width: vw(220);
      height: vw(60);
      border-radius: vw(5);
      border: vw(2) solid rgba(255, 255, 255, 1);
      background-color: transparent;
      margin-top: vw(50);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon-play {
        width: vw(17);
        height: vw(18);
        margin-right: vw(10);
      }
      .btn-mes {
        font-size: vw(20);
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #f8f8f8;
      }
      &:hover {
        border: 2px solid #b2b2b2;
        background: rgba(0, 0, 0, 0.2);
      }
    }
    .haoke-register {
      border: vw(2) solid rgba(251, 89, 74, 1);
      margin-left: 20px;
      background: rgba(251, 89, 74, 1);

      &:hover {
        border: 2px solid rgba(251, 89, 74, 0.8);
        background: rgba(251, 89, 74, 0.8);
      }
    }
    // .cooperateBtn:hover{
    //     background-color: #FF6D00;
    //     color: #fff;
    // }
    .intro-des {
      width: vw(636);
      margin-top: vw(18);
      font-family: PingFangSC-Regular;
      font-size: vw(24);
      color: #f8f9fd;
      line-height: vw(33);
    }
    .intro-des-vw {
      width: vw(866);
    }
  }
  .video-box {
    width: 100%;
    height: 100%;
    object-fit: fill;
    padding-top: 20px;
    // background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/homevideo-poster.png') no-repeat center;
    background-size: 100% 100%;
  }
  .video-player {
    position: absolute;
    width: 800px;
    height: 450px;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
    .icon-close {
      position: absolute;
      top: -45px;
      right: -45px;
      width: 45px;
      height: 45px;
      cursor: pointer;
    }
  }
  .bannerVideo-gb {
    position: absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
    width: 1440px;
    img {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.video-player {
  .xgplayer-skin-default {
    .xgplayer-start {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      background: url(https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/icon-play.png);
      background-size: 100% 100%;
      margin: -35px auto auto -35px;
      .xgplayer-icon-play {
        display: none;
      }
    }
  }
}
</style>
